import {
  Box,
  Chip,
  Grid,
  IconButton,
  Stack,
  SvgIcon,
  Typography,
} from "@mui/material";
import { useContext } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { CampaignContext } from "screens/Campaigns/CreateCampaign/Context";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { isTruthy } from "helpers/methods";

interface CustomProps {
  setIsDesignEmailModalOpen: Function;
  design: {
    index: number | null;
    content: string;
    contentPlain: string;
    contentJson: any;
  };
  setDesign: Function;
  designAB: {
    index: number;
    content: string;
    contentPlain: string;
    contentJson: any;
  }[];
}

const DesignSectionTestingVariable = (props: CustomProps) => {
  const { managingStep, submitCampaign } = useContext(CampaignContext);

  const stepCompletion = (index: number) => {
    return isTruthy(props.designAB[index]?.content) ?? false;
  };

  const getPreview = () => {
    const gridCount = 12 / (submitCampaign.abTestDetails?.testingVariants ?? 1);
    return (
      <Grid container spacing={2}>
        {Array.from({
          length: submitCampaign.abTestDetails?.testingVariants ?? 0,
        }).map((child, index: number) => {
          return (
            <Grid item xs={12} md={gridCount}>
              <Stack spacing={1}>
                {props.designAB[index]?.content ?? "" ? (
                  <iframe
                    srcDoc={props.designAB[index].content}
                    height="250px"
                    style={{
                      border: "1px solid rgba(71, 85, 105, 0.25)",
                      borderRadius: "12px",
                    }}
                  />
                ) : (
                  <Stack
                    height="250px"
                    width="100%"
                    sx={{ backgroundColor: "#DCE2EB", borderRadius: "12px" }}
                  ></Stack>
                )}
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Stack direction="row" spacing={0.5}>
                    <SvgIcon>
                      <CheckCircleIcon
                        htmlColor={
                          stepCompletion(index) ? "#7551D0" : "#C1C1C1"
                        }
                      />
                    </SvgIcon>
                    <Typography>{`Version ${index + 1}`}</Typography>
                  </Stack>
                  <Stack direction="row">
                    <IconButton
                      size="small"
                      onClick={() => {
                        props.setDesign({
                          index,
                          content: props.designAB[index].content,
                          contentPlain: props.designAB[index].contentPlain,
                          contentJson: props.designAB[index].contentJson,
                        });
                        props.setIsDesignEmailModalOpen(true);
                      }}
                    >
                      <SvgIcon fontSize="small">
                        <ModeEditIcon fontSize="small" />
                      </SvgIcon>
                    </IconButton>
                  </Stack>
                </Stack>
              </Stack>
            </Grid>
          );
        })}
      </Grid>
    );
  };

  const getView = () => {
    const onAnotherStep =
      managingStep !== "" && managingStep !== "design-section";
    return (
      <Stack
        direction="row"
        justifyContent="space-between"
        sx={{ opacity: onAnotherStep ? 0.5 : 1 }}
        spacing={4}
      >
        <Stack width="100%">
          <Stack direction="row" justifyContent="space-between" mb={2}>
            <Stack spacing={0.5}>
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography variant="h4">Design</Typography>
                <Chip label={"Testing Variable"} />
              </Stack>
              <Typography variant="body1">
                Click on the edit icon to design the version
              </Typography>
            </Stack>
          </Stack>
          {getPreview()}
        </Stack>
      </Stack>
    );
  };

  const getPage = () => {
    return getView();
  };

  return <Box px={3}>{getPage()}</Box>;
};

export default DesignSectionTestingVariable;
